import { Button } from '@kerfjs/ui/button';
import { List } from '@kerfjs/ui/list';
import { StateBanner } from '@kerfjs/ui/state-banner';
import { type SafeHtml } from 'kerfjs';

import { PageLoading } from '../../../components/page-loading.js';
import { aiUsage, aiUsageLoadState, notice, settings, settingsPage } from '../../../data/state.js';
import { type OrganizationPage, settingsPageFor } from '../../../lib/settings-nav.js';
import { OrgSettingsPage } from '../../settings/org-settings-page.js';

/** One Organization settings page at a time, chosen in the settings sidebar (HS2-91S2YF). */
export function OrganizationSettingsView(): SafeHtml {
  const page = settingsPageFor('organization', settingsPage.value) as OrganizationPage;
  const failedUsage = settings.value !== null && page === 'ai-usage' && aiUsageLoadState.value === 'error';
  const loadingUsage = settings.value !== null && page === 'ai-usage' && aiUsage.value === null && !failedUsage;
  const loading = (settings.value === null && notice.value === '') || loadingUsage;
  return (
    <section class="organization-settings-view" data-page-loading={loading ? '' : undefined}>
      {settings.value === null ? (
        notice.value === '' ? (
          <PageLoading label="Loading settings" />
        ) : (
          <StateBanner tone="info" title={notice.value} />
        )
      ) : failedUsage ? (
        <StateBanner
          tone="danger"
          title="AI Usage Unavailable"
          detail="Could not load usage and budget. Try again."
          action={
            <Button tone="neutral" emphasis="primary" size="default" action="retry-ai-usage">
              Retry
            </Button>
          }
        />
      ) : loadingUsage ? (
        <PageLoading label="Loading usage" />
      ) : (
        <List gap="m">
          <OrgSettingsPage settings={settings.value} page={page} />
          {notice.value !== '' ? <StateBanner tone="info" title={notice.value} /> : null}
        </List>
      )}
    </section>
  );
}
